import AskQuestionToAgentFormContainer from '@react/cta/components/AskQuestionToAgentFormContainer';
import Main from '@react/shared/components/Main';
import Separator from '@react/shared/components/Separator';
import { useToast } from '@react/shared/components/Toast';
import { CONSULTATION_REQUESTED } from '@sly/core/constants/actionTypes';
import { NOTIFY_AGENT_RECEIVED_REQUEST } from '@sly/core/constants/notification';
import { AgentsContentProps } from 'sly/agentsPage/components/AgentsContent/AgentsContent.types';
import FAQSection from 'sly/agentsPage/components/AgentsContent/FAQSection';
import InfoTiles from 'sly/agentsPage/components/AgentsContent/InfoTiles';
import AgentsSection from 'sly/agentsPage/components/AgentsSection';

import MostSearchedRegions from './MostSearchedRegions';

export default function AgentsContent({ heroRef }: AgentsContentProps) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { pushSuccess: notifyInfo } = useToast();

  const onConsultationRequested = () => {
    notifyInfo(NOTIFY_AGENT_RECEIVED_REQUEST);
  };

  return (
    <Main>
      <AgentsSection>
        <InfoTiles />
      </AgentsSection>
      <Separator fullWidth />
      <AgentsSection>
        <MostSearchedRegions />
      </AgentsSection>
      <Separator fullWidth />
      <AgentsSection className='w-full md:w-[var(--col6)]'>
        <AskQuestionToAgentFormContainer
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          hasLocation
          actionType={CONSULTATION_REQUESTED}
          postSubmit={() => {
            onConsultationRequested();
            if (heroRef.current) {
              heroRef.current.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        />
      </AgentsSection>
      <Separator fullWidth />
      <AgentsSection>
        <FAQSection />
      </AgentsSection>
    </Main>
  );
}
